import { render, staticRenderFns } from "./WeeklyTemplatePlanner.vue?vue&type=template&id=52a18404&scoped=true"
import script from "./WeeklyTemplatePlanner.vue?vue&type=script&lang=js"
export * from "./WeeklyTemplatePlanner.vue?vue&type=script&lang=js"
import style0 from "./WeeklyTemplatePlanner.vue?vue&type=style&index=0&id=52a18404&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52a18404",
  null
  
)

export default component.exports